import { FarmCsrFileType } from '../enums/farm-csr-type-file.enum'
import { IsEnum, IsNotEmpty, IsString } from 'class-validator'

export class SaveFarmCsrFile {
  @IsString()
  @IsNotEmpty()
  date: string | undefined

  @IsString()
  @IsEnum(FarmCsrFileType)
  @IsNotEmpty()
  type: FarmCsrFileType | undefined

  constructor(farmCsrFile?: SaveFarmCsrFile) {
    this.date = farmCsrFile?.date
    this.type = farmCsrFile?.type
  }
}
